
<script setup lang="ts">
//#region types
export interface Props {
  icon?: string,
  actionName?: string,
  color?: string,
}

export interface Emits {
  'click': [event: PointerEvent]
}
//#endregion

const props = withDefaults(defineProps<Props>(), {
  icon: 'pen',
  actionName: '',
  color: 'var(--text-link)',
});

const emit = defineEmits<Emits>();
</script>

<template>
  <div
    class="ui-action t:space-x-4"
    :style="{color: color}"
    @click="($event: PointerEvent) => emit('click', $event)"
  >
    <UiIcon
      :name="props.icon"
      color="inherit"
    />
    <span v-if="actionName">{{ actionName }}</span>
  </div>
</template>

<style lang="scss">
.ui-action {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 12px;
  text-decoration: none;
}
</style>
